import PropTypes from "prop-types";
import SavedItemsProductTileList from "../../../containers/common/SavedItemsProductTileList";
import LazyLoadObserver from "../../../containers/common/LazyLoadObserver";
import { isFullyLoaded } from "../../../../state/modules/savedItems/selectors/itemStateSelectors";
import isLastBestPriceEnabled from "../../common/SavedItemsProductTiles/isLastBestPriceEnabled";
import AppDownloadBanner from "../../common/AppDownloadBanner";
import useHandleResize from "./useHandleResize";
import useMatchMedia from "../../common/useMatchMedia";
import webContextProvider from "../../../../providers/webContextProvider";
import { isTablet } from "../ProductTiles/utils";
import ProductTilePlaceholder from "../ProductTilePlaceholder";
import media from "../../../../styles/customMedia.json";
import GoogleAdvert from "../GoogleAdvert";
import styles from "../../common/ProductTilesWrapper/index.css";

const SavedItemsProductTiles = ({
  savedItems,
  ProductTile,
  showDiscountLabel,
  isAuthenticated
}) => {
  const {
    customMedia: { ["--large-viewport"]: largeViewport }
  } = media;

  const showExtendedPricing = isLastBestPriceEnabled();
  const { adPosition } = useHandleResize();
  const isLargeViewport = useMatchMedia(largeViewport);
  const { platform } = webContextProvider();
  const isTab = isTablet();

  const savedProductTilesCollection = savedItems.map((item, index) => (
    <li key={item.id}>
      {isFullyLoaded(item) ? (
        <ProductTile
          {...{
            ...item,
            index,
            showDiscountLabel,
            showExtendedPricing,
            isAuthenticated
          }}
        />
      ) : (
        <ProductTilePlaceholder itemState={item.itemState} />
      )}
    </li>
  ));

  const shouldShowQrCode =
    isLargeViewport &&
    platform === "desktop" &&
    !isTab &&
    savedItems.length > 0;

  if (shouldShowQrCode) {
    savedProductTilesCollection.push(
      <li key="app-download-banner">
        <AppDownloadBanner />
      </li>
    );
  }

  savedProductTilesCollection.splice(
    adPosition,
    0,
    <li
      id="google-advert-list-item"
      key="google-advert"
      className={styles.fullWidthListItem}
    >
      <GoogleAdvert
        savedItemsCount={savedItems.length}
        adPosition={adPosition}
      />
    </li>
  );

  return (
    <>
      <SavedItemsProductTileList>
        {savedProductTilesCollection}
      </SavedItemsProductTileList>
      <LazyLoadObserver />
    </>
  );
};

SavedItemsProductTiles.propTypes = {
  ProductTile: PropTypes.elementType.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  ),
  showDiscountLabel: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

export default SavedItemsProductTiles;
